module.exports = __webpack_public_path__ + "static/media/infoJumbo1.24f293c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aerolift/images/infoJumbo1.jpg
// module id = 530
// module chunks = 0